<app-header-n *ngIf="lider?.lider==='Triidy'" (scroll)="onWindowScroll($event);"></app-header-n>
<div>
    <ngx-spinner bdColor="rgba(206,58,6,0.8)" size="medium" color="#fff" type="ball-newton-cradle" [fullScreen]="true">
        <p style="color: white !important"> {{mensaje}} </p>
    </ngx-spinner>
</div>
<div class="container">
    <div class="row" *ngIf="!succes">
        <div class="col info-col">
            <p class="title">
                <b>Ahora el comercio electrónico está al <span class="triidy-color">alcance de todos</span></b>
            </p>
            <p class="info">Gestiona y organiza los procesos financieros, logísticos y de producto de tu ecommerce a través de nuestra plataforma Triidy
            </p>
            <div class="cont-img">
                <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Registro-new.png" alt="">
            </div>
        </div>
        <div class="col">
            <div class="c-reg">
                <!--<div class="alert alert-success" *ngIf="succes">
                    <strong class="default"><i class="far fa-check-circle"></i> Tienda guardada</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                </div>
                <div class="alert alert-info" *ngIf="succes">
                    <strong class="default"><i class="far fa-check-circle"></i> Su clave por defecto: 123</strong>
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                </div>-->
                <div class="lider-container">
                    <mat-label><b>Lider: <span class="title-lider" *ngIf="lider">{{lider?.lider}}</span></b>
                    </mat-label>
                </div>
                <mat-vertical-stepper *ngIf="isVisible" [linear]="isLinear" #stepper>
                    <mat-step [stepControl]="registroFormGroup1">
                        <form [formGroup]="registroFormGroup1">
                            <div class="lab-mat">
                                <ng-template matStepLabel><span class="te-si">Datos de
                                        la tienda
                                    </span></ng-template>
                                <p>
                                    <mat-form-field class="nombre-campo">
                                        <mat-label>Nombre de la tienda</mat-label>
                                        <input matInput placeholder="Nombre de la tienda" maxlength="45" formControlName="nombreTienda" #tienda required>
                                        <mat-hint>{{tienda.value?.length || 0}}/45</mat-hint>
                                        <mat-error *ngIf="getControl('nombreTienda' , 1).errors">Nombre de la tienda incorrecto
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field class="email-campo">
                                        <mat-label>Email</mat-label>
                                        <input matInput placeholder="Email" formControlName="email" required>
                                        <mat-error *ngIf="getControl('email' , 1).errors">Email incorrecta</mat-error>
                                    </mat-form-field>
                                </p>

                                <p>
                                    <mat-form-field class="direccion-campo">
                                        <mat-label>Direccion</mat-label>
                                        <input matInput placeholder="Dirección" maxlength="45" formControlName="direccion" required>
                                        <mat-error *ngIf="getControl('direccion' , 1).errors">Dirección incorrecta
                                        </mat-error>
                                    </mat-form-field>
                                </p>
                                <p>
                                    <mat-form-field class="pais-campo">
                                        <mat-select formControlName="pais" [(value)]="selectPais" (ngModelChange)="selectPaisChange($event)" class="pais-selected" style="background-image: url({{selectPais?.url_bandera}});">
                                            <mat-option *ngFor="let pais of paises" [value]="pais">
                                                <img style="width: 5vw;" [src]="pais.url_bandera" alt="">{{pais.pais}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field class="ciudad-campo">
                                        <!--<input type="text" placeholder="Ciudad" aria-label="Number" matInput formControlName="ciudad" [matAutocomplete]="auto">-->
                                        <mat-error *ngIf="getControl('ciudad' , 1).errors">Ciudad incorrecta</mat-error>
                                        <!--<mat-autocomplete #auto="matAutocomplete">
                                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.ciudad" (onSelectionChange)="onSelectedOption(option)">
                                                {{option.ciudad}}
                                            </mat-option>
                                        </mat-autocomplete>-->
                                        <mat-label>Ciudad</mat-label>
                                        <mat-select formControlName="ciudad" required>
                                            <mat-option *ngFor="let option of Cities" [value]="option.ciudad" (onSelectionChange)="onSelectedOption(option)">
                                                {{option.ciudad}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </p>

                                <!--<p>
                                    <mat-form-field class="telefono-campo">
                                        <mat-label>Teléfono</mat-label>
                                        <input matInput placeholder="Teléfono" maxlength="12" pattern="\d*" formControlName="telefono" required>
                                        <mat-error *ngIf="getControl('telefono' , 1).errors">Teléfono incorrecto
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field class="cedula-campo">
                                        <mat-label>Cédula</mat-label>
                                        <input matInput pattern="\d*" maxlength="12" placeholder="Cédula" formControlName="cedula" #cedula required>
                                        <mat-hint>{{tienda.value?.length || 0}}/12</mat-hint>
                                        <mat-error *ngIf="getControl('cedula' , 1).errors">Cédula incorrecta</mat-error>
                                    </mat-form-field>
                                </p>-->
                            </div>

                            <div>
                                <button mat-button matStepperNext>Continuar</button>
                            </div>
                        </form>
                    </mat-step>
                    <mat-step [stepControl]="registroFormGroup2">
                        <form [formGroup]="registroFormGroup2">
                            <ng-template matStepLabel><span class="te-si">Datos del administrador</span></ng-template>
                            <p>
                                <mat-form-field class="nombre-adm-campo">
                                    <mat-label>Nombre completo</mat-label>
                                    <input matInput placeholder="Nombre completo" maxlength="45" formControlName="nombreCompletoAdm" #nombreadm required>
                                    <mat-hint>{{nombreadm.value?.length || 0}}/45</mat-hint>
                                    <mat-error *ngIf="getControl('nombreCompletoAdm' , 2).errors">Nombre incorrecto
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field class="celular-adm-campo">
                                    <mat-label>Celular</mat-label>
                                    <input matInput placeholder="Celular" maxlength="10" pattern="\d*" formControlName="celularAdm" required>
                                    <mat-error *ngIf="getControl('celularAdm' , 2).errors">Celular incorrecto
                                    </mat-error>
                                </mat-form-field>

                            </p>
                            <p>
                                <!--<mat-form-field class="telefono-adm-campo">
                                    <mat-label>Teléfono</mat-label>
                                    <input matInput placeholder="Teléfono" maxlength="12" pattern="\d*" formControlName="telefonoAdm" required>
                                    <mat-error *ngIf="getControl('telefonoAdm' , 2).errors">Teléfono incorrecto
                                    </mat-error>
                                </mat-form-field>-->

                                <mat-form-field class="usuario-adm-campo">
                                    <mat-label>Usuario</mat-label>
                                    <input matInput placeholder="usuario" maxlength="15" formControlName="usuarioAdm" (blur)="validaUsuarioUnfocus($event)" #usuario required>
                                    <mat-icon matSuffix class="material-symbols-outlined" *ngIf="isErrorUser" style="color: red">error_outlined</mat-icon>
                                    <mat-icon matSuffix class="material-symbols-outlined" *ngIf="isCorrectUser" style="color:darkgreen">check_circle_outlined</mat-icon>
                                    <mat-hint>{{usuario.value?.length || 0}}/15</mat-hint>
                                    <mat-error *ngIf="getControl('usuarioAdm' , 2).errors">Usuario ya existe</mat-error>
                                </mat-form-field>

                                <mat-form-field class="clave-adm-campo">
                                    <mat-label>Contraseña</mat-label>
                                    <input matInput [type]="hidePass ? 'password' : 'text'" name="passA" id="passA" formControlName="claveAdm" autocomplete="false" required>
                                    <button mat-icon-button matSuffix (click)="hidePass = !hidePass" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePass">
                                        <mat-icon>{{hidePass ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    </button>
                                    <mat-error *ngIf="getControl('claveAdm' , 2).errors">Clave erronea</mat-error>
                                </mat-form-field>

                            </p>
                            <div>
                                <button mat-button matStepperPrevious>Volver</button>
                                <button mat-button matStepperNext>Continuar</button>
                            </div>
                        </form>
                    </mat-step>

                    <!--<mat-step [stepControl]="registroFormGroup3">
                        <form [formGroup]="registroFormGroup3">
                            <ng-template matStepLabel><span class="te-si">Contacto Operativo</span></ng-template>
                            <p>
                                <mat-form-field class="nombre-contacto-campo">
                                    <mat-label>Nombre</mat-label>
                                    <input matInput placeholder="Nombre completo" maxlength="45" formControlName="nombreContacto" #nombrecont required>
                                    <mat-hint>{{nombrecont.value?.length || 0}}/45</mat-hint>
                                    <mat-error *ngIf="getControl('nombreContacto' , 3).errors">Nombre incorrecto
                                    </mat-error>
                                </mat-form-field>

                                <mat-form-field class="celular-contacto-campo">
                                    <mat-label>Celular</mat-label>
                                    <input matInput placeholder="Celular" maxlength="12" pattern="\d*" formControlName="celularContacto" required>
                                    <mat-error *ngIf="getControl('celularContacto' , 3).errors">Celular incorrecto
                                    </mat-error>
                                </mat-form-field>

                            </p>

                            <div>
                                <button mat-button matStepperPrevious>Volver</button>
                                <button mat-button matStepperNext>Continuar</button>
                            </div>
                        </form>
                    </mat-step>-->

                    <mat-step [stepControl]="registroFormGroup4">
                        <form [formGroup]="registroFormGroup4">
                            <ng-template matStepLabel><span class="te-si">Información Adicional</span></ng-template>
                            <!--<p>
                                <mat-form-field class="ventas-campo">
                                    <!--<input type="text" placeholder="Total Ventas" maxlength="20" matInput formControlName="totalVentas" [matAutocomplete]="auto2" readonly required>-->
                            <!--<mat-error *ngIf="getControl('totalVentas', 4).errors">Información incorrecta
                                    </mat-error>
                                    <mat-label>Total Ventas Mensuales</mat-label>
                                    <mat-select formControlName="totalVentas" required>
                                        <mat-option *ngFor="let nosotros of opcNosotros" [value]="nosotros" (onSelectionChange)="onSelectedOption2(nosotros)">
                                            {{nosotros}}
                                        </mat-option>
                                    </mat-select>

                                </mat-form-field>

                            </p>-->
                            <p>

                                <mat-form-field class="entero-campo">
                                    <mat-label>Como te enteraste de nosotros</mat-label>
                                    <input matInput placeholder="Como te enteraste de nosostros" maxlength="45" formControlName="comoNosotros" #nosotros required>
                                    <mat-hint>{{nosotros.value?.length || 0}}/45</mat-hint>
                                    <mat-error *ngIf="getControl('comoNosotros' , 4).errors">Información incorrecto
                                    </mat-error>
                                </mat-form-field>

                            </p>

                            <!--<div>
                                <button mat-button matStepperPrevious>Volver</button>
                                <button mat-button matStepperNext>Continuar</button>
                            </div>-->
                            <div>
                                <button mat-button matStepperPrevious>Volver</button>
                                <button mat-button (click)="limpiarInfo()">Limpiar informacion</button>
                                <button mat-button (click)="saveInfo()">Guardar</button>
                            </div>
                        </form>
                    </mat-step>

                    <!--<mat-step>
                        <ng-template matStepLabel><span class="te-si">Completo</span></ng-template>
                        <p>Informacion completa</p>
                        <div>
                            <button mat-button matStepperPrevious>Volver</button>
                            <button mat-button (click)="limpiarInfo()">Limpiar informacion</button>
                            <button mat-button (click)="saveInfo()">Guardar</button>
                        </div>
                    </mat-step>-->
                </mat-vertical-stepper>
            </div>

        </div>
    </div>
</div>
<app-footer-n *ngIf="lider?.lider==='Triidy'"></app-footer-n>

<app-modal-reg *ngIf="vistaRegistro" (modalSelect)="closeModal($event)" [showClose]="false"></app-modal-reg>